import { useModal } from '@/components/L/Modal/useModal';
import OnboardingModal from '@/modules/onboarding/OnboardingModal.vue';
import { showStandaloneBubble } from '@/modules/onboarding/standaloneBubble';
import { NotificationDescriptor } from '@/modules/notifications/models/NotificationDescriptor';

/** Renders a notification and resolves when the user dismisses/closes it. */
export class NotificationPresenter {
  public present(notification: NotificationDescriptor): Promise<void> {
    const anchor = notification.anchorSelector
      ? document.querySelector(notification.anchorSelector)
      : null;
    // Anchored + element on screen → onboarding standalone bubble; otherwise a centered modal.
    return anchor ? this.presentBubble(notification) : this.presentModal(notification);
  }

  private async presentModal(notification: NotificationDescriptor): Promise<void> {
    const { openModal, } = useModal();
    // `await` (not `return`) so the ignored Promise<unknown> resolution isn't propagated as the
    // method's Promise<void> result.
    await openModal(
      OnboardingModal, {
        modalData: {
          name: 'Lenda',
          title: notification.title(),
          description: notification.description(),
          // Single dismiss button: OnboardingModal skips the secondary one when `falseText` is
          // absent (a tour passes both). No modalType => the default Lenda logo.
          trueText: notification.trueText(),
        },
      }, {
        style: 'z-index: 303;',
      });
  }

  private presentBubble(notification: NotificationDescriptor): Promise<void> {
    return showStandaloneBubble({
      target: notification.anchorSelector!,
      content: `${notification.title()}${notification.description()}`,
      buttonLabel: notification.trueText(),
      placement: notification.anchorPlacement ?? 'right',
    // Bubble couldn't render → fall back to the modal so the notification is never lost.
    }).catch(() => this.presentModal(notification));
  }
}
